export const WARNING_MESSAGE_ON_APPLY = 'The end date must be greater than the start date';
export const MAX_ALLOWED_COMPARISON_PERIODS = 3;
export const MAX_ALLOWED_CUSTOM_CLASSES = 10;
export const SEGMENT_CUSTOM_FEATURE = 'segment_custom_feature';
export const FEATURE_SEGMENT = 'feature_segment';
